import i18n from "./i18n"; // i18n setup file where translations are managed
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider, useTranslation } from "react-i18next";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from "js-cookie";
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const Root = () => {
  const { i18n } = useTranslation();

  // Handle language switch (example for English and Arabic)
  const [language, setLanguage] = useState(i18n.language);

  const changeLanguage = (lang) => {
    let neLang = language === 'en'?'ar':'en';
    i18n.changeLanguage(neLang);
    setLanguage(neLang);
    Cookies.set("selectedLanguage", neLang, { expires: 365 }); // Store language
  };

  useEffect(() => {
    // Update the lang and direction based on the selected language
    document.documentElement.lang = i18n.language; // Set the language in <html>
    // document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr"; // Update direction (rtl for Arabic, ltr for others)
    setLanguage(i18n.language)
  }, [i18n.language]);

  return (
    <div>
      {/* Language Switcher (can be a button or dropdown) */}
      {/* <div className='bg-red-200 flex justify-center gap-5 fixed w-full z-50'>
        <div className='flex gap-2'>
          <span className={`mt-1.5 ${language==='en'?'font-bold text-green-500':''}`}>English</span>
          <Switch
            checked={language==="ar"}
            onChange={changeLanguage}
            inputProps={{ 'aria-label': 'controlled' }}
          />
          <span className={`mt-1.5 ${language==='ar'?'font-bold text-green-500':''}`}>العربية</span>
        </div>
      </div> */}

      <div>
      <App language={language} />
        <ToastContainer/>
      </div>
    </div>
  );
};
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
    <Root />
    </I18nextProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
